import { __exports as constants } from "./index218.js";
var hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants;
  hasRequiredConstants = 1;
  Object.defineProperty(constants, "__esModule", {
    value: true
  });
  constants.START_BIN = "1010";
  constants.END_BIN = "11101";
  constants.BINARIES = ["00110", "10001", "01001", "11000", "00101", "10100", "01100", "00011", "10010", "01010"];
  return constants;
}
export {
  requireConstants as __require
};
//# sourceMappingURL=index190.js.map
